<template>
    <div class="root" v-loading="loading">


        <topmenu></topmenu>

        <div class="container theme-showcase">

            <div style="font-size: 22px; text-align: center; margin: 20px 0;">Check-in</div>

            <div style="display: flex;">
                <div style="flex: 1; line-height: 36px;">
                    <!-- <el-checkbox v-model="AutoCheckin">Auto Check-in</el-checkbox>
    <el-checkbox v-model="AutoPrint">Auto Print</el-checkbox> -->
                </div>

                <div style="margin-left: 12px;">
                    <el-select v-model="eventId" size="medium" placeholder="Select" @change="eventChange">
                        <el-option v-for="item in eventList" :key="item.id" :label="item.eventName" :value="item.id">
                        </el-option>
                    </el-select>
                </div>

            </div>

            <div style="display: flex; margin:20px 0;">
                <div>
                    <el-input v-model="preRegNo" placeholder="enter" autofocus @input="inputChange"></el-input>
                </div>
                <div style="margin-left: 20px;">
                    <el-button icon="el-icon-search" @click="search">Search</el-button>
                </div>
                <!-- <div style="margin-left: 20px;">
    <el-button type="primary" icon="el-icon-check" @click="checkin">Check-in</el-button>
</div>
<div style="margin-left: 20px;">
    <el-button type="success" icon="el-icon-printer" @click="print">Print</el-button>
</div> -->
            </div>

            <div>
                <table v-if="showDetails" style="width:100%; border-left: 1px #ccc solid; border-top: 1px #ccc solid;">
                    <tr>
                        <td class="mytd">Category Name</td>
                        <td class="mytd">First Name</td>
                        <td class="mytd">Last Name</td>
                        <td class="mytd">Reg No</td>
                        <td class="mytd">Reg Time</td>
                        <td class="mytd">Badge Print Time</td>
                    </tr>
                    <tr class="el-table__body-wrapper is-scrolling-none">
                        <td class="mytd">{{ visitorCateName }}</td>
                        <td class="mytd">{{ firstName }}</td>
                        <td class="mytd">{{ lastName }}</td>
                        <td class="mytd">{{ regNo }}</td>
                        <td class="mytd">{{ onSiteRegDt }}</td>
                        <td class="mytd">{{ badgePrintDT }}</td>
                    </tr>
                </table>
                <div v-else style="text-align: center; padding: 30px 0;">
                    no date
                </div>
            </div>

            <div style="display: flex; text-align: center; margin: 20px 0;" v-if="showDetails">
                <div style="margin-left: 20px; ">
                    <el-button type="primary" icon="el-icon-check" @click="checkin">Check-in</el-button>
                </div>
                <div style="margin-left: 20px;">
                    <!-- <el-button type="success" icon="el-icon-printer" @click="print">Print</el-button> -->
                </div>
            </div>
        </div>



        <!-- content -->
        <div style=""  >
            <div class="container2 theme-showcase">
                <div class="container" >
                    <vue-drag-resize-rotate :w="w" :h="h" :x="x" :y="y" @resizing="resizing" @rotating="rotating"
                        :rotatable="true">
                        {{ angle }}
                    </vue-drag-resize-rotate>


                    <vue-drag-resize-rotate :x="0" :y="0" :w="200" :h="200">
                        <p>你可以拖着我，按照自己的意愿调整大小。1</p>
                    </vue-drag-resize-rotate>
                    <vue-drag-resize-rotate :x="200" :y="200" :w="200" :h="200">
                        <p>你可以拖着我，按照自己的意愿调整大小。2</p>
                    </vue-drag-resize-rotate>

                </div>
                <div id="divcanvas"><img v-if="imgUrl != ''" :src="imgUrl" /></div>

                <div >
                    <el-button @click="btnDrawPrint">html2canvas2</el-button>
                </div>
            </div>
        </div>
        <!-- content -->

        <div style="width: 200px; height:300px; background-color: #cacaca;" id="printJSDiv" ref="printJSDiv">
            asdfasf
        </div>

    </div>
</template>

<script>

import axios from 'axios'
import topmenu from '../home/components/topmenu'
import VueDragResizeRotate from "@gausszhou/vue-drag-resize-rotate";
import html2canvas from 'html2canvas';
import printJS from "print-js";


export default {
    name: 'catelist',
    data: function () {
        return {
            preRegNo: '',
            AutoCheckin: false,
            AutoPrint: false,
            id: 0,
            eventId: '',
            eventList: [],
            loading: false,
            dialogFormVisible: false,
            angle: 0,
            x: 0,
            y: 0,
            w: 100,
            h: 100,
            imgUrl: '',
            showDetails: false
        }
    },
    components: {
        topmenu,
        VueDragResizeRotate
    },
    methods: {
        print() {

        },
        checkin() {
            this.loadCheckin();
        },
        search() {
            this.loadData();
        },
        inputChange(res) {
            console.log(res);
            if (res != null && res != undefined && res.length >= 5) {
                // this.loadData();
            }
        },


        btnDrawPrint() {
            var that = this;
            html2canvas(that.$refs.printJSDiv, {
                width: that.$refs.printJSDiv.clientWidth,
                height: that.$refs.printJSDiv.clientHeight,
            }).then((canvas) => {
                const url = canvas.toDataURL();
                printJS({
                    printable: url,
                    type: 'image',
                    maxWidth: 9999,
                    style: `body{margin:0}`,
                });
            });
        },

        resizing(x, y, w, h) {
            console.log(x, y, w, h);
            this.w = w;
            this.h = h;
            this.x = x;
            this.y = y;
        },
        rotating(angle) {
            console.log(angle)
        },

        tableRowClassName({ row, rowIndex }) {
            if (rowIndex === 1) {
                return 'warning-row';
            } else if (rowIndex === 3) {
                return 'success-row';
            }
            return '';
        },
        goBack() {
            this.$router.back();
        },
        submit() {
            if (this.Name == '') {
                this.nameErr = "required";
                return;
            } else {
                this.nameErr = "";
            }
            if (this.eventId == '' || this.eventId == 0) {
                this.$message.error('Please select Event');
                return;
            }
            this.onSubmit();
        },
        nameChange(val) {
            console.log(val);
            if (val != '' && val.length > 0) { this.nameErr = ''; }
            else {
                this.nameErr = "required";
            }
        },
        onSubmit() {
            this.loading = true;
            this.btnDis = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));

            var uid = userJson.uid;
            var token = userJson.token;
            axios.post('api/Visitor/editCategory',
                {
                    uid: uid,
                    token: token,
                    id: this.id,
                    eventid: this.eventId,
                    name: this.Name,
                    isDefault: this.IsDefault,
                    badgeTempId: this.BadgeTemplate,
                    startTime: this.StartTime,
                    endTime: this.EndTime
                }
            )
                .then(this.submitSucc)
        },
        submitSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.$message({
                    message: 'Success!',
                    type: 'success',
                    onClose: () => {
                    }
                });
                this.dialogFormVisible = false;
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        loadCheckin() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Visitor/getOne',
                {
                    code: this.preRegNo,
                    skip: 0,
                    limit: 1,
                    eventId: this.eventId,
                    checkin: true,
                    print: false,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadCheckinSucc)
        },
        loadCheckinSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.list = res.list;
                if (res.list != null && res.list.length > 0) {
                    var item = res.list[0];
                    this.showDetails = true;
                    this.preRegNo = '';
                    this.firstName = item.firstName;
                    this.lastName = item.lastName;
                    this.onSiteRegDt = item.onSiteRegDt;
                    this.regNo = item.preRegNo;
                    this.visitorCateName = item.visitorCateName;
                    this.badgePrintDT = item.badgePrintDT;

                    console.log(item);
                } else {
                    this.showDetails = false;
                    this.preRegNo = '';
                    this.firstName = '';
                    this.lastName = '';
                    this.onSiteRegDt = '';
                    this.regNo = '';
                    this.visitorCateName = '';
                    this.badgePrintDT = '';
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        loadData() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/Visitor/getOne',
                {
                    code: this.preRegNo,
                    skip: 0,
                    limit: 1,
                    eventId: this.eventId,
                    checkin: this.AutoCheckin,
                    print: this.AutoPrint,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                this.list = res.list;
                if (res.list != null && res.list.length > 0) {
                    var item = res.list[0];
                    this.showDetails = true;
                    this.preRegNo = '';
                    this.firstName = item.firstName;
                    this.lastName = item.lastName;
                    this.onSiteRegDt = item.onSiteRegDt;
                    this.regNo = item.preRegNo;
                    this.visitorCateName = item.visitorCateName;
                    this.badgePrintDT = item.badgePrintDT;

                    console.log(item);
                } else {
                    this.showDetails = false;
                    this.preRegNo = '';
                    this.firstName = '';
                    this.lastName = '';
                    this.onSiteRegDt = '';
                    this.regNo = '';
                    this.visitorCateName = '';
                    this.badgePrintDT = '';
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        loadEvent() {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/event/getList',
                {
                    limit: 10000,
                    uid: userJson.uid,
                    token: userJson.token
                }
            )
                .then(this.loadEventSucc)
        },
        loadEventSucc(res) {
            this.loading = false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                if (res.list && res.list.length > 0) {
                    this.eventList = res.list;
                    console.log(this.eventList);
                    if (this.eventId == '' || this.eventId == 0) {
                        this.eventId = res.list[0].id;
                    }
                }
            } else {
                if (res && res.Code == 301) {
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },


        eventChange(id) {
            console.log(id);
            localStorage.setItem('eventId',id);
            this.currentPage = 1;
        },


    },
    mounted() {
        const id = this.$route.query.id;
        console.log(id)
        if (id != undefined && id != '') {

        }

        var eventId = localStorage.getItem('eventId');
        if (eventId != null && eventId != undefined) {
            eventId = parseInt(eventId);
            this.eventId = eventId;
        }

        this.loadEvent();
        var userJson = JSON.parse(localStorage.getItem("userJson"));
        console.log(userJson);
        var nickname = userJson['nickname'];
        this.nickname = nickname;
        console.log(this.nickname);
    },
    beforeDestroy() {

    }
}
</script>
<style scoped>
.mytd {
    border-bottom: 1px #ccc solid;
    border-right: 1px #ccc solid;
    padding: 10px;
    margin: 0;
    box-sizing: border-box;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}

.root>>>.topmenuitem:nth-child(9) {
    color: #fff;
    background-color: #080808;
}
</style>



// WEBPACK FOOTER //
// src/pages/general/checkin.vue